module.exports = __webpack_public_path__ + "media/images/icon_list/next-70e84b9ad3745245a6ae0a3bf983cd04.svg";